import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CopyrightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"copyright"}/>
}
